var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutWithContainer",
    { attrs: { small: true } },
    [
      _vm.$wait.is("fetching preview resource")
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("Spinner", { attrs: { height: 40, width: 40 } })],
            1
          )
        : [
            _c(
              "template",
              { slot: "header" },
              [
                _c("ContentHeader", {
                  attrs: {
                    title: _vm.sectorTitle,
                    "back-link-title": "Go Back",
                    "back-link": `/sectors/${_vm.sectorId}`,
                    bordered: false,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.resource
              ? [
                  _c("SectorPostCard", {
                    attrs: {
                      resource: _vm.resource,
                      "sector-id": _vm.sectorId,
                      "show-read-more": false,
                    },
                    on: {
                      "model-updated": _vm.handleModelUpdate,
                      deleted: _vm.handleDelete,
                    },
                  }),
                ]
              : _c("div", { staticClass: "failed" }, [
                  _c("span", [
                    _vm._v(
                      "This post may have been deleted or is no longer available."
                    ),
                  ]),
                ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }